import { Injectable } from '@angular/core';
import { CanActivate, Router, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlSegment, Route } from '@angular/router';
import { RegisterService } from './register.service';

@Injectable({
  providedIn: 'root'
})
export class RegisterGuardService implements CanActivate, CanActivateChild {

  constructor(private registerService: RegisterService) { }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(childRoute, state);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivateStep(route.data.step);
  }

  canActivateStep(pStep: number): boolean {
    const result = this.registerService.regStep >= pStep;
    if (result) {
      this.registerService.regStep = pStep;
    }

    return result;
  }

}
